import React from 'react'
import ListInfosContainer from './ListInfosContainer'

const ListInfos = props => (
  <ListInfosContainer {...props} data-test="component-stock-vehicle-detail-list-infos" />
)
export default ListInfos
